<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" :label-placeholder="$t('TitleLabel')" v-model="spaceTitle" />
      </div>
      <div class="vx-col w-full mb-base">
        <vs-textarea class="vx-col w-1/1 lg:w-1/1" style="width:100%;" :label-placeholder="$t('DescriptionLabel')" v-model="spaceDescription" />
      </div>
      <div v-if="!isSubspaceCreation" class="vx-col w-full mb-base">
        <vs-checkbox success v-model="hideSpaceFromSidebar">
          {{ $t('HideSpaceFromSidebar') }}
        </vs-checkbox>
      </div>
      <!--<div class="vx-col w-full mb-base">
    <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Subscription ID" v-model="spaceSubscriptionId" />
  </div>
  <div class="vx-col w-full mb-base">
    <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Payment Link" v-model="spacePaymentLink" />
  </div>
  <div class="vx-col w-full mb-base">
    <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Certificate Title" v-model="certificateTitle" />
  </div>
  <div class="vx-col w-full mb-base">
    <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Certificate Icon Path" v-model="certificateIcon" />
    <input type="file" @change="uploadCertificateIcon($event)" accept="image/*" style="margin-top: 8px;" />
  </div>
  <div class="vx-col w-full mb-base">
    <vs-textarea class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Certificate Description" v-model="certificateDescription" />
  </div>-->
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vs-button typeof="flat" @click="CreateSubspace()">{{ $t('CreateSpace') }}</vs-button>
      </div>
    </div>
  </div>
</template>


<script>
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  export default {
    props: ["isSubspaceCreation","parentId"],
    data() {
      return {
        spaceTitle: "",
        spaceDescription: "",
        hideSpaceFromSidebar: false
      }
    },
    mounted() {
      if (this.isSubspaceCreation) {
        this.hideSpaceFromSidebar = true
      }
      else {
        this.parentId = null
      }
    },

    methods: {
      CreateSubspace() {
        var instance = this
        const spaceVariables = {
          id: 0,
          title: instance.spaceTitle,
          description: instance.spaceDescription,
          icon: "",
          urlName: "",
          hideFromSidebar: instance.hideSpaceFromSidebar,
          parentId: instance.parentId * 1,
        }
        const query = `
    mutation AddSubspace($space: SpaceInput!) {
      addSubspace(entity: $space) {
        id,
        title,
        description,
        icon,
        urlName,
        hideFromSidebar,
        parentId,
        }
 }
`;
        const variables = {
          space: spaceVariables
        }

        const req = {
          query,
          variables
        };
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data.data) {
            instance.spaceTitle = ""
            instance.spaceDescription = ""
            instance.$vs.notify({
              title: instance.$t('Success'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            instance.$emit("space-creation-completed", response.data.data.addSubspace)
          }
          else if (response && response.data && response.data.errors) {
            alert(instance.$t('Error') + ' - There were some errors saving :( ');
            console.error("ERROR SAVING SPACE: ", response.data);
          }
        });

      },
    }

  }
</script>
